<template>
  <div class="nd-drag" ref="dragDom">
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NdDragNew',
  props: {
    defaultX: {
      type: String,
      default: ''
    },
    defaultY: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isDragged: false,
      domLeft: 0,
      domTop: 0,
      initX: 0,
      initY: 0,
      topPosition: 0 // 页面顶部的限制距离
    }
  },
  computed: {
    ...mapState({
      statusBarHeight: state => state.statusBarHeight || 0
    })
  },
  mounted () {
    setTimeout(() => {
      // 顶部距离修正，为确保顶部和底部的DOM加载完成，所以添加一个500ms的延迟
      this.topPosition += this.statusBarHeight
      const navDom = document.querySelector('.nd-navigation')
      if (navDom) {
        this.topPosition += navDom.offsetHeight
      }
      // TODO 这里减去了底部距离，应该还会减去app内部的header距离
      const tabbarDom = document.querySelector('.nd-tabbar')
      if (tabbarDom) {
        pageHeight -= tabbarDom.offsetHeight
      }
    }, 500)
    const dragDom = this.$refs.dragDom
    if (!dragDom) return
    // 页面宽度和高度
    const pageWidth = document.documentElement.clientWidth
    let pageHeight = document.documentElement.clientHeight
    // 拖拽元素宽度和高度
    const dragWidth = dragDom.offsetWidth
    const dragHeight = dragDom.offsetHeight

    // 初始化位置信息
    let dragPosition = null
    if (this.defaultX || this.defaultY) {
      dragPosition = {
        left: this.defaultX || 0,
        top: this.defaultY || 0
      }
    }
    if (dragPosition) {
      dragDom.style.left = dragPosition.left
      dragDom.style.top = dragPosition.top
    } else {
      dragDom.style.left = pageWidth - dragWidth + 'px'
      dragDom.style.top = pageHeight - dragHeight + 'px'
    }

    dragDom.addEventListener('touchstart', (e) => {
      e.stopPropagation()
      this.isDragged = true
      this.initX = e.touches[0].clientX
      this.initY = e.touches[0].clientY
      this.domLeft = dragDom.offsetLeft
      this.domTop = dragDom.offsetTop
    })
    dragDom.addEventListener('touchmove', (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (this.isDragged) {
        const x = e.touches[0].clientX
        const y = e.touches[0].clientY
        // 鼠标移动的距离
        const offsetX = x - this.initX
        const offsetY = y - this.initY
        // 鼠标移动后元素的新位置
        const newLeft = this.domLeft + offsetX
        const newTop = this.domTop + offsetY

        if (newLeft < 0) {
          dragDom.style.left = 0 + 'px'
        } else if (newLeft > pageWidth - dragWidth) {
          dragDom.style.left = pageWidth - dragWidth + 'px'
        } else {
          dragDom.style.left = newLeft + 'px'
        }
        if (newTop < this.topPosition) {
          dragDom.style.top = this.topPosition + 'px'
        } else if (newTop > pageHeight - dragHeight) {
          dragDom.style.top = pageHeight - dragHeight + 'px'
        } else {
          dragDom.style.top = newTop + 'px'
        }
      }
    })
    dragDom.addEventListener('touchend', () => {
      this.isDragged = false
    })
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.nd-drag{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
</style>